import {
  SET_IMAGE_SEARCH_DATA,
  CLEAR_IMAGE_SEARCH_DATA,
  SET_IMAGE_SEARCH_FETCHING,
  SET_IMAGE_SEARCH_ERROR,
} from './actions';

const initialState = {
  data: null,
  isFetching: false,
  error: null,
};

const imageSearchReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_IMAGE_SEARCH_DATA:
      return {
        ...state,
        data: action.payload,
        isFetching: false,
        error: null,
      };
    case CLEAR_IMAGE_SEARCH_DATA:
      return {
        ...state,
        data: null,
        isFetching: false,
        error: null,
      };
    case SET_IMAGE_SEARCH_FETCHING:
      return {
        ...state,
        isFetching: action.payload,
        error: null,
      };
    case SET_IMAGE_SEARCH_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default imageSearchReducer;
